var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 1.5H3.5C2.67157 1.5 2 2.17157 2 3V10C2 10.8284 2.67157 11.5 3.5 11.5H14.5C15.3284 11.5 16 10.8284 16 10V3C16 2.17157 15.3284 1.5 14.5 1.5ZM3.5 0C1.84315 0 0.5 1.34315 0.5 3V10C0.5 11.6569 1.84315 13 3.5 13H14.5C16.1569 13 17.5 11.6569 17.5 10V3C17.5 1.34315 16.1569 0 14.5 0H3.5Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.99302 7.83707L0.568437 2.61339L1.43156 1.38661L8.85614 6.61028C8.94244 6.671 9.05756 6.671 9.14385 6.61028L16.5684 1.3866L17.4316 2.61339L10.007 7.83707C9.40292 8.26207 8.59708 8.26207 7.99302 7.83707Z","key":1})]);
}

Email.defaultProps = {"width":"18","height":"13","viewBox":"0 0 18 13","fill":"none"};

module.exports = Email;

Email.default = Email;
